/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TopTopTime API
 * <:3 )~~~~    =^.^=
 * OpenAPI spec version: 0.0.1
 */

export enum ProspectStatus {
  new = 'new',
  contacted = 'contacted',
  replied = 'replied',
  interested = 'interested',
  bounced = 'bounced',
  optout = 'optout'
}
